import React, { Component, Fragment } from 'react';
import { Button, Form, Header, Input, Segment } from 'semantic-ui-react';
import axios from 'axios';
import {
    fetchCantons,
    fetchCountries,
    fetchDisabledAccesses,
    fetchEntities,
    fetchMunicipalities,
    fetchOrganizationalUnits,
    fetchRightTypes
} from '../Lookups/util';
import { DEFAULT_NUMBER_OF_ITEMS_PER_PAGE, formatListForDropdownOptions } from '../util/util';
import { toast, ToastContainer } from 'react-toastify';
import {FACULTY_ADMIN} from "../util/roles";

class NewProperty extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lookups: {
                municipalities: [],
                cantons: [],
                entities: [],
                countries: [],
                rightTypes: [],
                disabledAccesses: [],

                street: '',
                placeName: '',
                municipality: null,
                canton: null,
                entity: null,
                country: null,
                propertyName: '',
                rightType: null,
                usefulSurface: '',
                teachingArea: '',
                disabledAccess: null,
            },

        };

        this.handleMunicipalityChange = this.handleMunicipalityChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleEntityChange = this.handleEntityChange.bind(this);
        this.handleCantonChange = this.handleCantonChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        localStorage.setItem('organizationalUnitId', this.props.organizationalUnitId);
        // this.setState({ organizationalUnitId: this.props.organizationalUnitId });
    }

    addProperty() {
        if (
            this.state.organizationalUnitId === null || this.state.organizationalUnitId === undefined
            || this.state.street === undefined || this.state.street === null || this.state.street === ''
            || this.state.placeName === undefined || this.state.placeName === null || this.state.placeName === '' ||
            this.state.country === null || this.state.country === undefined
            || this.state.propertyName === undefined || this.state.propertyName === null || this.state.propertyName === ''
            || this.state.rightType === undefined || this.state.rightType === null
            || this.state.usefulSurface === undefined || this.state.usefulSurface === null || this.state.usefulSurface === ''
            || this.state.teachingArea === undefined || this.state.teachingArea === null || this.state.teachingArea === '' ||
            ((this.state.canton === undefined || this.state.canton === null) && !this.state.disabledCanton) || ((this.state.municipality === undefined || this.state.municipality === null) && !this.state.disabledMunicipality) ||
            ((this.state.entity === undefined || this.state.entity === null) && !this.state.disabledEntity) || (this.state.disabledAccess === undefined || this.state.disabledAccess === null)
        ) {
            this.setState({
                organizationalUnitError: !this.state.organizationalUnitId,
                streetError: !this.state.street || this.state.street === '',
                placeError: !this.state.placeName || this.state.placeName === '',
                countryError: !this.state.country,
                propertyNameError: !this.state.propertyName || this.state.propertyName === '',
                rightTypeError: !this.state.rightType,
                usefulSurfaceError: !this.state.usefulSurface || this.state.usefulSurface === '',
                teachingAreaError: !this.state.teachingArea || this.state.teachingArea === '',
                disabledAccessError: !this.state.disabledAccess,
                municipalityError: this.state.municipality === null && !this.state.disabledMunicipality,
                cantonError: this.state.canton === null && !this.state.disabledCanton,
                entityError: this.state.entity === null && !this.state.disabledEntity,
            });

            toast('Nisu sva potrebna polja popunjena!');
            return;
        }


        const propertyRequest = {
            organizationalUnit: { id: this.state.organizationalUnitId },
            property: {
                name: this.state.propertyName,
                address: {
                    street: this.state.street,
                    place: {
                        name: this.state.placeName,
                        municipality: this.state.municipality ? { id: this.state.municipality } : null,
                        canton: this.state.canton ? { id: this.state.canton } : null,
                        entity: this.state.entity ? { id: this.state.entity } : null,
                        country: this.state.country ? { id: this.state.country } : null,
                    }
                },
                disabledAccess: this.state.disabledAccess ? { id: this.state.disabledAccess } : null,
            },
            rightType: this.state.rightType ? { id: this.state.rightType } : null,
            usefulSurface: this.state.usefulSurface,
            teachingArea: this.state.teachingArea,
            disabledAccess: this.state.disabledAccess ? { id: this.state.disabledAccess } : null,
            active: 1
        };


        axios.post('/assets/organizational-unit-properties/', { ...propertyRequest })
            .then(res => {
                // if (this.state.showFiltersOnButton) {
                //     this.getFilteredOrganizationalUnitProperties(this.state.activePage - 1, this.state.resultsPerPage);
                // } else {
                //     this.getOrganizationalUnitProperties(this.state.activePage - 1, this.state.resultsPerPage);
                // }
                this.props.closeForm();
                this.props.fetchOrganizationalUnitProperties();
                toast('Zahtjev uspješno poslan!');
                // this.resetValues(null);
            })
            .catch(err => {
                console.log(err);
                toast('Došlo je do greške prilikom dodavanja nepokretne imovine!');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }
    handleMunicipalityChange(e, { value }) {
        const municipality = this.state.municipalitiesOptions.find(el => el.id === value);

        const canton = municipality.canton ? municipality.canton.id : null;
        const entity = municipality.entity ? municipality.entity.id : null;
        const country = municipality.country ? municipality.country.id : null;
        this.setState({
            municipality: value,
            canton,
            entity,
            country,
        });
    }

    handleEntityChange(e, { value }) {
        let {
            canton, municipality, disabledMunicipality, disabledCanton, allowedMunicipalities
        } = this.state;

        canton = null;
        municipality = null;
        const country = this.state.countriesOptions.find(el => el.name === 'Bosna i Hercegovina');

        if (value === 3) {
            disabledCanton = true;
            disabledMunicipality = true;
        } else if (value === 2) {
            disabledCanton = true;
            disabledMunicipality = false;
        } else {
            disabledCanton = false;
            disabledMunicipality = false;
        }

        allowedMunicipalities = this.state.municipalitiesOptions.filter(el => el.entity && el.entity.id === value);

        this.setState({
            entity: value,
            canton,
            municipality,
            country: country.id,
            disabledCanton,
            disabledMunicipality,
            allowedMunicipalities
        });
    }

    handleCantonChange(e, { value }) {
        let { allowedMunicipalities } = this.state;
        allowedMunicipalities = this.state.municipalitiesOptions.filter(el => el.canton && el.canton.id === value);
        const entity = this.state.entitiesOptions.find(el => el.name === 'Federacija Bosne i Hercegovine');
        const country = this.state.countriesOptions.find(el => el.name === 'Bosna i Hercegovina');
        this.setState({
            allowedMunicipalities,
            canton: value,
            municipality: null,
            entity: entity.id,
            country: country.id,
        });
    }

    handleCountryChange(e, { value }) {
        let {
            disabledEntity, disabledCanton, disabledMunicipality
        } = this.state;

        if (value === 22) {
            disabledEntity = false;
            disabledCanton = false;
            disabledMunicipality = false;
        } else {
            disabledEntity = true;
            disabledCanton = true;
            disabledMunicipality = true;
        }

        this.setState({
            country: value,
            disabledEntity,
            disabledCanton,
            disabledMunicipality,
            municipality: null,
            entity: null,
            canton: null,
            allowedMunicipalities: this.state.municipalitiesOptions,
        });
    }
    componentDidMount() {
        this.setState({ organizationalUnitId: this.props.organizationalUnitId });
        localStorage.setItem('organizationalUnitId', this.props.organizationalUnitId);
        axios.all([fetchOrganizationalUnits(), fetchMunicipalities(), fetchCantons(), fetchEntities(), fetchCountries(), fetchRightTypes(), fetchDisabledAccesses()])
            .then(axios.spread((orgUnitsRes, municipalitiesRes, cantonsRes, entitiesRes, countriesRes, rightTypesRes, disabledAccessesRes) => {
                const orgUnits = formatListForDropdownOptions(orgUnitsRes.data);
                const municipalities = formatListForDropdownOptions(municipalitiesRes.data);
                const cantons = formatListForDropdownOptions(cantonsRes.data);
                const entities = formatListForDropdownOptions(entitiesRes.data);
                const countries = formatListForDropdownOptions(countriesRes.data);
                const rightTypes = formatListForDropdownOptions(rightTypesRes.data);
                const disabledAccesses = formatListForDropdownOptions(disabledAccessesRes.data);

                const lookups = {
                    orgUnits,
                    municipalities,
                    cantons,
                    entities,
                    countries,
                    rightTypes,
                    disabledAccesses,
                };

                this.setState({
                    orgUnitsOptions: orgUnits,
                    municipalitiesOptions: municipalities,
                    cantonsOptions: cantons,
                    entitiesOptions: entities,
                    countriesOptions: countries,
                    rightTypesOptions: rightTypes,
                    disabledAccessesOptions: disabledAccesses,
                    allowedMunicipalities: municipalities
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch lookup data.', err);
            });
    }


    render() {

        return (
            // eslint-disable-next-line react/jsx-no-undef
            <Fragment>

                <Segment clearing secondary>
                    <Form noValidate>

                        <Form.Group widths="equal">
                            <Form.Field
                                control={Input}
                                label="Naziv imovine"
                                name="propertyName"
                                value={this.state.propertyName}
                                onChange={this.handleInputChange}
                                placeholder="Naziv imovine"
                                required
                                error={this.state.propertyNameError}
                            />
                            {/*<Form.Dropdown*/}
                            {/*    clearable*/}
                            {/*    label="Organizaciona jedinica"*/}
                            {/*    placeholder="Organizaciona jedinica"*/}
                            {/*    value={this.state.organizationalUnitId}*/}
                            {/*    onChange={this.handleInputChange}*/}
                            {/*    name="organizationalUnitId"*/}
                            {/*    options={this.state.orgUnitsOptions}*/}
                            {/*    search*/}
                            {/*    fluid*/}
                            {/*    required*/}
                            {/*    error={this.state.organizationalUnitError}*/}
                            {/*    selection*/}
                            {/*/>*/}

                            <Form.Field
                                control={Input}
                                label="Ulica"
                                name="street"
                                value={this.state.street}
                                onChange={this.handleInputChange}
                                placeholder="Unesite ulicu"
                                required
                                error={this.state.streetError}
                            />
                            <Form.Field
                                control={Input}
                                label="Mjesto"
                                name="placeName"
                                value={this.state.placeName}
                                onChange={this.handleInputChange}
                                placeholder="Unesite naziv mjesta"
                                required
                                error={this.state.placeError}
                            />


                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Dropdown
                                clearable
                                label="Opština"
                                placeholder="Opština"
                                value={this.state.municipality}
                                name="municipality"
                                onChange={this.handleMunicipalityChange}
                                options={this.state.allowedMunicipalities}
                                search
                                fluid
                                disabled={this.state.disabledMunicipality}
                                required={!this.state.disabledMunicipality}
                                error={this.state.municipalityError}
                                selection
                            />
                            <Form.Dropdown
                                clearable
                                label="Kanton"
                                placeholder="Kanton"
                                value={this.state.canton}
                                name="canton"
                                onChange={this.handleCantonChange}
                                options={this.state.cantonsOptions}
                                search
                                fluid
                                disabled={this.state.disabledCanton}
                                required={!this.state.disabledCanton}
                                error={this.state.cantonError}
                                selection
                            />

                            <Form.Dropdown
                                clearable
                                label="Entitet"
                                placeholder="Entitet"
                                value={this.state.entity}
                                name="entity"
                                onChange={this.handleEntityChange}
                                options={this.state.entitiesOptions}
                                search
                                fluid
                                disabled={this.state.disabledEntity}
                                required={!this.state.disabledEntity}
                                error={this.state.entityError}
                                selection
                            />

                            <Form.Dropdown
                                clearable
                                label="Država"
                                placeholder="Država"
                                value={this.state.country}
                                name="country"
                                onChange={this.handleCountryChange}
                                options={this.state.countriesOptions}
                                search
                                fluid
                                required
                                error={this.state.countryError}
                                selection
                            />


                        </Form.Group>

                        <Form.Group widths="equal">

                            <Form.Dropdown
                                clearable
                                label="Tip prava"
                                placeholder="Tip prava"
                                value={this.state.rightType}
                                name="rightType"
                                onChange={this.handleInputChange}
                                options={this.state.rightTypesOptions}
                                search
                                fluid
                                required
                                error={this.state.rightTypeError}
                                selection
                            />
                            <Form.Dropdown
                                clearable
                                label="Pristup invalidima"
                                placeholder="Pristup invalidima"
                                value={this.state.disabledAccess}
                                name="disabledAccess"
                                onChange={this.handleInputChange}
                                options={this.state.disabledAccessesOptions}
                                search
                                fluid
                                selection
                                required
                                error={this.state.disabledAccessError}
                            />
                            <Form.Field
                                control={Input}
                                label="Korisna površina (m²)"
                                name="usefulSurface"
                                type="number"
                                value={this.state.usefulSurface}
                                onChange={this.handleInputChange}
                                placeholder="Korisna površina"
                                required
                                error={this.state.usefulSurfaceError}
                            />

                            <Form.Field
                                control={Input}
                                label="Površina za učenje (m²)"
                                name="teachingArea"
                                type="number"
                                value={this.state.teachingArea}
                                onChange={this.handleInputChange}
                                placeholder="Površina za učenje"
                                required
                                error={this.state.teachingAreaError}
                            />

                        </Form.Group>

                        <Button
                            onClick={this.props.closeForm}
                            basic
                            floated="right"
                            color="blue"
                        >Odustani
                        </Button>
                        <Button
                            floated="right"
                            color="blue"
                            onClick={
                                () => {
                                    this.addProperty();
                                }
                            }
                        >
                            Kreiraj
                        </Button>
                    </Form>
                </Segment>

            </Fragment>
        );
    }
}

export default NewProperty;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/NewProperty.js